import styled from 'styled-components';
import { rgba } from 'polished';

import { c14142E, c1D1D37, cFFFFFF } from '#/colors';

export const Container = styled.button`
  background: ${c14142E};
  border-radius: 7px;
  border: none;
  display: grid;
  font-size: 13px;
  font-weight: 700;
  gap: 4px;
  grid-template-columns: 20px auto;
  height: 32px;
  padding: 0 8px;
  place-items: center;
  width: 138px;

  &:hover {
    background-color: ${c1D1D37};
  }
`;

export const Address = styled.span`
  margin: 0;
  color: ${rgba(cFFFFFF, 0.7)};
`;
